import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './layout/boundary/ErrorBoundary';

const root = createRoot(
  document.getElementById('root')
);

Modal.setAppElement('#root')

root.render(
<React.StrictMode>
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
